import { render, staticRenderFns } from "./LoginReauthModal.vue?vue&type=template&id=315dd0b5&scoped=true"
import script from "./LoginReauthModal.vue?vue&type=script&lang=js"
export * from "./LoginReauthModal.vue?vue&type=script&lang=js"
import style0 from "./LoginReauthModal.vue?vue&type=style&index=0&id=315dd0b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315dd0b5",
  null
  
)

export default component.exports